// 0元抽奖相关路由
export default {
  routes: [
    // 抽奖首页
    {
      path: '/freeLuckyDraw/index',
      name: 'freeLuckyDrawIndex',
      meta: {
        desc: '0元抽奖首页'
      },
      component: () =>
        import(/* webpackChunkName: "freeLuckyDrawIndex" */ '../views/freeLuckyDraw/index.vue')
    },
    // 抽奖详情页
    {
      path: '/freeLuckyDraw/activityDetail',
      name: 'freeLuckyDrawIndexActivityDetail',
      meta: {
        desc: '0元抽奖详情页'
      },
      component: () =>
        import(
          /* webpackChunkName: "freeLuckyDrawIndexActivityDetail" */ '../views/freeLuckyDraw/activityDetail.vue'
        )
    },
    // 我的抽奖页
    {
      path: '/freeLuckyDraw/myList',
      name: 'freeLuckyDrawMyList',
      meta: {
        desc: '0元抽奖我的抽奖页'
      },
      component: () =>
        import(/* webpackChunkName: "freeLuckyDrawMyList" */ '../views/freeLuckyDraw/myList.vue')
    },
    // 浏览商品页
    {
      path: '/freeLuckyDraw/browseGoods',
      name: 'freeLuckyDrawBrowseGoods',
      meta: {
        desc: '0元抽奖商品页'
      },
      component: () =>
        import(
          /* webpackChunkName: "freeLuckyDrawBrowseGoods" */ '../views/freeLuckyDraw/browseGoods.vue'
        )
    },
    // 填写地址页
    {
      path: '/freeLuckyDraw/address',
      name: 'freeLuckyDrawAddress',
      meta: {
        desc: '0元抽奖填写地址页'
      },
      component: () =>
        import(/* webpackChunkName: "freeLuckyDrawAddress" */ '../views/freeLuckyDraw/address.vue')
    }
  ]
}
